module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticStyle: {
      "height": "100%",
      "border": "1px solid #eee"
    }
  }, [_c('el-aside', {
    attrs: {
      "width": "260px"
    }
  }, [_c('el-menu', {
    attrs: {
      "default-openeds": ['1'],
      "theme": "dark"
    }
  }, [_c('div', {
    staticClass: "brand"
  }, [_vm._v("Samsung Promotool")]), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" Dashboard")])], 1)], 1), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    on: {
      "click": _vm.unpublishedPromo
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" Unpublished Promo")])])], 1)], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-header', {
    staticStyle: {
      "text-align": "right",
      "font-size": "12px",
      "height": "auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.publishData('staging')
      }
    }
  }, [_vm._v("Publish Staging")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.publishData('live')
      }
    }
  }, [_vm._v("Publish Live")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "lang"
  }, [_vm._v(_vm._s(_vm.$lang))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down",
    staticStyle: {
      "margin-right": "15px"
    }
  }), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.update$lang('nl')
      }
    }
  }, [_vm._v("NL")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.update$lang('be')
      }
    }
  }, [_vm._v("BE")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.update$lang('be_fr')
      }
    }
  }, [_vm._v("BE_FR")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])], 1)], 1), _vm._v(" "), _c('el-main', [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10528294","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Default.vue
// module id = 209
// module chunks = 1